// processToastrs.js
'use strict';
import getOperationData from '../selector/getOperationData.js';
import getModalData from '../selector/getModalData.js';
import addModal from '../action/addModal.js';
import removeModals from '../action/removeModals.js';
import { SET_OPERATION_DATA } from '../ActionTypes.js';

const ANIMATE_OUT_MSEC = 700; // TODO: remote config
let timeout = null;

/**
 * Process toastrs
 * @kind action
 * @return {Promise} Action promise.
 */
const processToastrs = () => async (dispatch, getState) => {
  const now = Date.now();
  let firstStartTimestamp =
    getOperationData(getState(), ['toastr'], 'firstStartTimestamp') || now;
  let toastrs = [];
  const [firstToastr, ...comingToastrs] =
    getOperationData(getState(), ['toastr'], 'stacks') || [];

  if (!firstToastr) {
    clearTimeout(timeout);
    timeout = null;
    return { type: '' };
  }

  const firstHiddenTimestamp =
    firstStartTimestamp + 1000 * firstToastr.durationSec;
  if (now >= firstHiddenTimestamp) {
    firstStartTimestamp = null;
    toastrs = comingToastrs;
    const firstToastrZIndex = getModalData(getState(), 'Toastr', 'zIndex');
    if (firstToastrZIndex) {
      dispatch(removeModals({ ids: ['Toastr'] }));
    }
    if (comingToastrs[0]) {
      firstStartTimestamp = now;
      dispatch(
        addModal({
          id: 'Toastr',
          transitionStatus: 'coming',
          isHigherThanAll: true,
        })
      );
      clearTimeout(timeout);
      timeout = setTimeout(
        () => dispatch(processToastrs()),
        1000 * comingToastrs[0].durationSec - ANIMATE_OUT_MSEC
      );
    }
  } else if (now >= firstHiddenTimestamp - ANIMATE_OUT_MSEC) {
    toastrs = [firstToastr, ...comingToastrs];
    dispatch(removeModals({ ids: ['Toastr'], transitionStatus: 'leaving' }));
    clearTimeout(timeout);
    timeout = setTimeout(
      () => dispatch(processToastrs()),
      firstHiddenTimestamp - Date.now()
    );
  } else if (now < firstHiddenTimestamp - ANIMATE_OUT_MSEC) {
    toastrs = [firstToastr, ...comingToastrs];
    const firstToastrZIndex = getModalData(getState(), 'Toastr', 'zIndex');
    if (!firstToastrZIndex) {
      dispatch(
        addModal({
          id: 'Toastr',
          transitionStatus: 'coming',
          isHigherThanAll: true,
        })
      );
    }
    clearTimeout(timeout);
    timeout = setTimeout(
      () => dispatch(processToastrs()),
      firstStartTimestamp +
        1000 * firstToastr.durationSec -
        ANIMATE_OUT_MSEC -
        now
    );
  }

  return dispatch({
    type: SET_OPERATION_DATA,
    payload: {
      selectPath: ['toastr'],
      data: {
        firstStartTimestamp,
        stacks: toastrs,
      },
    },
  });
};

export default processToastrs;
